import { Clipboard } from '@angular/cdk/clipboard';
import { Component, Input } from '@angular/core';
import { MessageService } from 'primeng/api';

export interface SerialItem {
  serial_number?: string | null;
  asset_code?: string | null;
}

/**
 * Pulsante con il numero dei seriali di una riga: apre la modale con l'elenco (copiabile negli
 * appunti). Disabilitato se non ci sono seriali.
 */
@Component({
  selector: 'app-serials-button',
  templateUrl: './serials-button.component.html',
})
export class SerialsButtonComponent {
  @Input() serials: SerialItem[] | null | undefined;
  /** Nome del prodotto/riga, mostrato nell'intestazione della modale */
  @Input() title?: string | null;

  visible = false;
  copied = false;

  constructor(
    private clipboard: Clipboard,
    private messageService: MessageService
  ) {}

  get list(): SerialItem[] {
    return this.serials ?? [];
  }

  get count(): number {
    return this.list.length;
  }

  open() {
    if (this.count > 0) this.visible = true;
  }

  copy() {
    if (this.count === 0) return;
    this.copied = this.clipboard.copy(this.list.map(s => s.serial_number ?? '').join('\r\n'));
    if (!this.copied) return;
    this.messageService.clear();
    this.messageService.add({ severity: 'success', summary: 'Copiato negli appunti', life: 2000 });
    setTimeout(() => (this.copied = false), 2000);
  }
}
